interface Tab<T extends string> {
  id: T;
  label: string;
  hidden?: boolean;
}

interface TabBarProps<T extends string> {
  tabs: Tab<T>[];
  activeTab: T;
  onTabChange: (tab: T) => void;
  className?: string;
}

function getTabClassName(containerClass: string): string {
  if (containerClass === "editor-tabs") return "editor-tab";
  if (containerClass === "result-tabs") return "result-tab";
  if (containerClass === "unified-tabs") return "unified-tab";
  return "editor-tab";
}

export function TabBar<T extends string>({
  tabs,
  activeTab,
  onTabChange,
  className = "editor-tabs",
}: TabBarProps<T>) {
  const tabClass = getTabClassName(className);

  return (
    <div className={className}>
      {tabs
        .filter((tab) => !tab.hidden)
        .map((tab) => (
          <div
            key={tab.id}
            className={`${tabClass} ${activeTab === tab.id ? "active" : ""}`}
            onClick={() => onTabChange(tab.id)}
          >
            {tab.label}
          </div>
        ))}
    </div>
  );
}
